import type { FC } from 'react'

import { minWidthFromTheme, SearchOutline16, Tag } from '@sok/design-system'
import { useTranslation } from 'react-i18next'
import { useQueryStringParam } from 'services/Search/hooks/use-query-string-param'
import styled from 'styled-components'
import { useURLSearchParams } from 'utils/hooks/use-url-search-params'

const Spacer = styled.span(({ theme }) => ({
  marginLeft: theme.spacings.xxxSmall,
}))

const _ClearQueryStringFilter: FC<{ className?: string }> = ({ className }) => {
  const queryString = useQueryStringParam()
  const { removeParams } = useURLSearchParams()
  const { t } = useTranslation()

  const handleClose = () => removeParams(['queryString', undefined])

  if (!queryString) return null

  return (
    <Tag
      className={className}
      closable
      data-test-id="category-search-querystring"
      onClose={handleClose}
    >
      <SearchOutline16 /> <Spacer>{t('Quoted text', { text: queryString })}</Spacer>
    </Tag>
  )
}

/**
 * Display a closable Tag with the current search `queryString`
 * if available. This is to help remove the queryString when
 * navigating on category pages.
 */
export const ClearQueryStringFilter = styled(_ClearQueryStringFilter)(({ theme }) => ({
  alignSelf: 'flex-start',
  margin: `0 0 ${theme.spacings.medium} 8px`,

  [minWidthFromTheme(theme).desktop]: {
    margin: `0 0 0 4px`,
  },
}))
